import * as React               from 'react';
import { StatelessComponent }   from 'react';

interface Props {
    className?: string;
    onClick: (event) => void;
    label: string;
}

const Button: StatelessComponent<Props> = ({ className, onClick, label }) => (
    <div
        className={className}
        onClick={onClick}
    >
        {label}
    </div>
);

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.tsx